import { Element } from "./Element";
import { debug, runExecuteCode, runIfCode } from "./common";
import { Initializer } from "./Initializer";
import { ProxyHandler } from "./ProxyHandler";
/**
 * Custom Element
 */
export class CustomElement extends Element {
    /**
     * Constructor
     * @param htmlElement html element
     * @param bindData bind data
     * @param context contxt
     * @protected
     */
    constructor(htmlElement, bindData, context) {
        super(htmlElement, bindData, context);
    }
    /**
     * Checks available state
     */
    isAvailable() {
        return document.contains(this.htmlElement);
    }
    /**
     * Renders element
     */
    render() {
        runIfCode(this.getHtmlElement(), this.getContext()).then(result => {
            if (result == false) {
                return;
            }
            this.doRender(this.getBindData());
            Initializer.initialize(this.getHtmlElement(), this.getContext());
            runExecuteCode(this.getHtmlElement(), this.getContext()).then();
        });
    }
    /**
     * Implements update method
     * @param observable observable
     * @param event event
     */
    update(observable, event) {
        debug('ObjectElement.update', observable, event);
        if (observable instanceof ProxyHandler) {
            this.doUpdate(observable.getTarget());
        }
    }
}
//# sourceMappingURL=CustomElement.js.map